import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Grid, makeStyles, Button } from "@material-ui/core";
import Seperator from "components/Seperator";
import { Add } from "@material-ui/icons";
import { useTranslation } from "react-i18next";
import WeekPicker from "./WeekPicker"; // mui-picker v3
import moment from "moment";
import { useHistory } from "react-router-dom";
import {
  ADD_EDIT_PUNCH_SUPERVISOR,
  ADD_TIMESHEET,
  SUPERVISOR_PTO,
} from "navigation/CONSTANTS";
import { selectedWeekOnReview } from "../../../redux/actions/appActions";
import { useDispatch, useSelector } from "react-redux";
// import { getRcArrayParam } from "services/firebase";
import { properCase } from "utils";
import { convertStringToArray } from "utils/rcUtils";
import { useRemoteConfig } from "providers";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    padding: theme.spacing(1),
    textAlign: "center",
    color: theme.palette.text.secondary,
  },
}));

const PunchHeader = (props) => {
  const { t } = useTranslation();
  const [startDate, setStartDate] = props.dateHandles;
  const { isAllPunchView } = props;
  const {allPunches} =props;
  const history = useHistory();
  const dispatch = useDispatch();
  const { worker, workers } = props;
  const [isTimesheetDisabled, setIsTimesheetDisabled] = useState(true); //state management for timesheet link visibility

  const supervisor = useSelector((state) => state.user);  
  const punchAccess = useRemoteConfig('punchAccess');
  const ptoAccess = useRemoteConfig('ptoAccess');
  const timesheetAccess = useRemoteConfig('timesheetAccess');
  const punchAccessCountries = convertStringToArray(punchAccess);
  const ptoApplicableCountries = convertStringToArray(ptoAccess);
  const timesheetAccessCountries = convertStringToArray(timesheetAccess);
  const [isAddDisabled, setIsAddDisabled] = useState(true);
  const [isAddPTODisabled, setIsAddPTODisabled] = useState(true);

  const { isAuthenticated, user } = useSelector((state) => state.user.auth);

  useEffect(() => {
    setIsAddDisabled(true);
    if (
      supervisor.auth &&
      supervisor.auth.user &&
      supervisor.auth.user.country &&
      ((worker && worker.firstName && worker.isActiveWorker) || workers)
    ) {
      if (punchAccessCountries.includes(supervisor.auth.user.country)) {
        setIsAddDisabled(false);
      }
      if (ptoApplicableCountries.includes(supervisor.auth.user.country)) {
        setIsAddPTODisabled(false);
      }
    }
  }, [supervisor]);

  //handles the effects whenever authentication or user changes for showing timesheet link
  useEffect(() => {
    setIsTimesheetDisabled(true);
    console.log("PUNCHACCESSCOUNTRIES:"+JSON.stringify(punchAccessCountries));
    console.log("PTOAPPLICABLECOUNTRIES:"+JSON.stringify(ptoApplicableCountries));
    console.log("TIMESHEETACCESSCOUNTRIES:"+JSON.stringify(timesheetAccessCountries));

    if (isAuthenticated) {
      // let timesheetAccessCountries = getRcArrayParam("timesheetAccess");

      if (user && user.country) {
        if (timesheetAccessCountries.includes(user.country)) {
          setIsTimesheetDisabled(false);
        }
      }
    }
  }, [isAuthenticated, user]);

  const weekChangeHandler = (date) => {
    console.log("PunchHeader > WeekPicker value changed===", date);
    var weekStart = moment(date).format();
    console.log("WEEK SELECTION: weekStart: ", weekStart);
    setStartDate(weekStart);
    dispatch(selectedWeekOnReview({ week: weekStart }));
  };

  const addTimesheet = () => {
    history.push(ADD_TIMESHEET, {
      worker: worker,
      workers: workers,
      allPunches:allPunches,
    });
  };
  const addPunchClick = () => {
    history.push(ADD_EDIT_PUNCH_SUPERVISOR, {
      worker: worker,
      punch: {},
      workers: workers,
      isAllPunch: isAllPunchView,
    });
  };

  // const addPTOClick = () => {
  //   history.push(SUPERVISOR_PTO, {
  //     worker: worker,
  //     punch: {},
  //     workers: workers,
  //     isAllPunch: isAllPunchView,
  //   });
  // };

  console.log("mindate mindate",moment(new Date()).subtract(3, "months").startOf('month'));
  return (
    <>
      <Grid container justify="space-between">
        <Grid item>
          <WeekPicker
            lbl={properCase(t("pgReview.lbWeekPicker"))}
            startDate={startDate}
            weekChangeHandler={weekChangeHandler}
            minDate={moment(new Date()).subtract(3, "months").startOf('month')}
            maxDate={moment(new Date()).add(2, "weeks")}
            //maxDate={new Date()}
          />
        </Grid>
        <Grid item>
          <Grid container justify="center" spacing={2}>
            {/* <Grid item>
              <Button
                variant="contained"
                color="primary"
                onClick={addPTOClick}
                disabled={isAddPTODisabled}
                startIcon={<Add />}
              >
                Leave
              </Button>
            </Grid> */}
            <Grid item>
              <Button
                variant="contained"
                color="primary"
                onClick={addPunchClick}
                disabled={isAddDisabled}
                startIcon={<Add />}
              >
                Activity
              </Button>
            </Grid>
            {!isTimesheetDisabled && (
              <Grid item>
                <Button
                  variant="contained"
                  color="primary"
                  startIcon={<Add />}
                  onClick={addTimesheet}
                >
                  {t("other.lblTimeSheet")}
                </Button>
              </Grid>
            )}
          </Grid>
        </Grid>
        <Seperator />
      </Grid>
    </>
  );
};

PunchHeader.propTypes = {
  dateHandles: PropTypes.array.isRequired,
  worker: PropTypes.any,
  workers: PropTypes.any,
  isAllPunchView: PropTypes.any,
};

export default PunchHeader;
